import FreeSpace from './ui/main/FreeSpace';

export default FreeSpace;
